import SubscriptionModal from './SubscriptionModal'

export default SubscriptionModal
